export default __webpack_public_path__ + "static/media/yelpCamp6.c14a29c8.jpg";